import { QueryPageResult, RuntimeModel, http } from '@kunlun/dependencies';
/**
 * 驻地导入
 *
 * @param {RuntimeModel} rModel
 * @param {{billPeriod: string, employeeId:[] }} params
 * @return {*}
 */
export async function submitCreateAttendanceReport(rModel: RuntimeModel, params: { billPeriod: string , employeeId : any[] }) {
    const employeeIds =
        params.employeeId?.length > 0
            ? `ids: ${JSON.stringify(params.employeeId).replace(/"/g, '')},`
            : ''

    const mutation = `
    mutation {
    deliAriesResidentBusinessEmployeeProxyMutation {
        generateDetail(data: { ${employeeIds} 
        billPeriod: "${params.billPeriod}" }) {
            id
        }
    }
}
  `;

    const res = await http.mutate<any[]>(rModel.moduleName, mutation);
    return res.data.deliAriesResidentBusinessEmployeeProxyMutation.generateDetail;
}


